import React from 'react';
import { MDBCard, MDBRow, MDBCol, MDBCardText, MDBCardHeader, MDBCardFooter, MDBBtn, MDBContainer } from
    "mdbreact";
import { Button } from 'react-bootstrap';

const Cta = () => {
    return (
        <>
            <MDBRow>
                <MDBCol style={{position: "absolute", top: "100%"}}>
            
                            <div style={{position: "relative"}}>
                        <Button target="_blank" href="https://github.com/cmsilvabarnbeck" color="transparent" type="button" style={{margin: '5px'}}>View GitHub</Button>
                        <Button href="http://barnbeckmedia.com/#contact" color="transparent" type="button" style={{ margin: '5px' }}>Hire</Button>
                            </div>
                        

                </MDBCol>
            </MDBRow>


        </>
    );
}

export { Cta }
